import React from 'react';

import { NotificationProvider } from './src/context/AddItemNotificationProvider';
import { AuthProvider } from './src/context/AuthProvider';

export const wrapRootElement = ({ element }) => (
  <NotificationProvider>
    <AuthProvider>{element}</AuthProvider>
  </NotificationProvider>
);
